import { PlatformLocation } from '@angular/common';
import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  constructor(private platformLocation: PlatformLocation) {}

  public getBaseUrl(): string {
    return (this.platformLocation as any).location.origin;
  }

  public getApiBaseUrl(): string {
    return environment.apiBaseUrl;
  }
}
